import { InterfaceOrganizationProduct } from '@manifest-cyber/types/interface/dbTables';
import classNames from 'classnames';
import { MRT_Row } from 'mantine-react-table';

export const TotalVulns = ({ row }: { row: MRT_Row<InterfaceOrganizationProduct> }) => {
  const totalVulns =
    row.original.countVulnerabilities?.total !== undefined
      ? row.original.countVulnerabilities?.total
      : 0; // MFST-1540: Show '0' instead of 'Not Provided'

  return (
    <p
      className={classNames({
        'table-na': !row.original.countVulnerabilities?.total,
      })}
    >
      {totalVulns}
    </p>
  );
};
